module.exports = __webpack_public_path__ + "nc_static/media/dd_process_information.9f1a8db2.svg";